export default __webpack_public_path__ + "static/media/img50.7f81ef51.jpg";